import { render } from "./Case.vue?vue&type=template&id=7b134c02&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"

import "./Case.vue?vue&type=style&index=0&id=7b134c02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b134c02"]])

export default __exports__